"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const IInvoice_1 = require("../models/invoice/IInvoice");
const GenericValidator_1 = __importDefault(require("./GenericValidator"));
const invoicePayrixTransaction_schema_1 = __importDefault(require("./schemas/invoicePayrixTransaction.schema"));
class InvoiceValidator extends GenericValidator_1.default {
    invoiceStatus = Object.values(IInvoice_1.IInvoiceStatus);
    invoicedBy = Object.values(IInvoice_1.IInvoicedBy);
    productizedBy = Object.values(IInvoice_1.IProductizedBy);
    _invoiceSchema = joi_1.default.object({
        id: joi_1.default.string().allow('').required(),
        orgKey: joi_1.default.string().required(),
        customerId: joi_1.default.string().required(),
        customerName: joi_1.default.string().required(),
        number: joi_1.default.string().allow('').required(),
        total: joi_1.default.number().required(),
        chargeCount: joi_1.default.number().required(),
        created: joi_1.default.number().required(),
        unpublishDate: joi_1.default.number().optional(),
        publishDate: joi_1.default.number().optional(),
        dueDate: joi_1.default.number().required(),
        paidDate: joi_1.default.number().optional(),
        reportingDate: joi_1.default.number().optional(),
        status: joi_1.default.string()
            .valid(...this.invoiceStatus)
            .required(),
        invoicedBy: joi_1.default.string()
            .valid(...this.invoicedBy)
            .required(),
        productizedBy: joi_1.default.string()
            .valid(...this.productizedBy)
            .optional(),
        poNumber: joi_1.default.string().optional(),
        trailerNumber: joi_1.default.string().optional(),
        bolNumber: joi_1.default.string().optional(),
        referenceNumber: joi_1.default.string().optional(),
        transactionId: joi_1.default.number().optional(),
        trackingNumber: joi_1.default.string().optional(),
        pdfStatus: joi_1.default.string().optional(),
        payrixTransaction: joi_1.default.object(invoicePayrixTransaction_schema_1.default).optional(),
        summary: joi_1.default.object({
            recurringStorage: joi_1.default.number().required(),
            transactionTypes: joi_1.default.object()
                .pattern(joi_1.default.string().required(), joi_1.default.object({
                total: joi_1.default.number().required(),
                categories: joi_1.default.object()
                    .pattern(joi_1.default.string(), joi_1.default.number().required())
                    .required(),
            }).required())
                .required(),
        }).optional(),
        paidBy: joi_1.default.string().optional(),
    });
    validate(input) {
        super.validate(input, 'IInvoice', this._invoiceSchema);
    }
}
exports.default = InvoiceValidator;
